const ASSET_VERSION = process.env.REACT_APP_ASSET_VERSION || '20260501-1';

export default function assetUrl(path: string): string {
  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}v=${ASSET_VERSION}`;
}
